import React, { Component } from "react";
import Simplefooter from "../footer/simplefooter";
import data from "../../mock/workshops-mock.json";
import negociosTagline from "../../assets/Curso_img/tags/tagline_negocios.png";
import tecnologiaTagline from "../../assets/Curso_img/tags/tagline_tecnologia.png";
import inovacaoTagline from "../../assets/Curso_img/tags/tagline_inovacoes.png";
// import bannerCursosVerao from "../../assets/banners/banner_cursos_de_verao.png"

// import bannerValentinesDay from "../../assets/banners/banner_valentines_day.png"
import BannerWorkshop from "../../assets/banners/Banner_WORKSHOP_2.png";
// import BannerWorkshop from "../../assets/banners/bannerblackfriday.png"

import "./workshop-style.css";
// importa o footer
import "../footer/footer";

export default class Workshop extends Component {
  constructor() {
    super();
    this.state = {
      data: [],
      selected: "Negócios",
      index: 0,
      renderLogin: false,
    };
  }

  componentWillMount() {
    this.setState({
      data: data,
    });
  }

  renderMenu(boxItem, index) {
    return (
      <li key={index}>
        <a
          href=""
          data-index={boxItem.index}
          data-name={boxItem.name}
          className={Number(this.state.index) === index ? "active" : ""}
          onClick={this.clickMenuItem.bind(this)}
        >
          {boxItem.name}
        </a>
      </li>
    );
  }

  clickMenuItem(e) {
    e.preventDefault();
    const elem = e.target.getAttribute("data-name");
    const index = e.target.getAttribute("data-index");
    this.setState({
      selected: elem,
      index: index,
    });
  }

  //AdICIONA O CURSO PARA CAIR DIRETO NO CALENDARIO

  onCourseClick(selectedCourse, courseIndex) {
    console.log(courseIndex);

    
    if (
      courseIndex == 100  
    ) {
      return this.props.history.push({
        pathname: `/calendar/${courseIndex}/${selectedCourse}`,
      });
    } else {
      return this.props.history.push({
        pathname: `/workshop-page/${courseIndex}/${selectedCourse}`,
      });
    }
  }

  renderContent(boxItem, index) {
    const url = `/workshop-page/${boxItem.index}/${boxItem.id}`;
    return (
      <div className="boxContent" key={index}>
        <div
          className="topBox"
          style={{ backgroundImage: `url(/imgs/banners_Card/${boxItem.img})` }}
        ></div>
        <div className="bottomBox">
          <h3>
            <a onClick={() => this.onCourseClick(boxItem.id, boxItem.index)}>
              {boxItem.title}
            </a>
          </h3>
          <p className="info">
            <span>|</span>
            {boxItem.duringTime}
            <span>|</span>
          </p>
          <p className="description">{boxItem.description}</p>
        </div>
        <div className="buttonBox">
          <a
            onClick={() => this.onCourseClick(boxItem.id, boxItem.index)}
            href={url}
            className="button primary-color"
          >
            Saiba mais
          </a>
        </div>
      </div>
    );
  }

  getDataBox() {
    const config = this.state.data.conteudo;

    return config.map((_config, index) => this.mountBoxData(index));
  }

  mountBoxData(index) {
    if (this.state.data.conteudo[index][0].section === this.state.selected) {
      const config = this.state.data.conteudo[index];
      return config.map((config, index) => this.renderContent(config, index));
    }
  }

  /**
   * Retorna uma lista formatada de cursos.
   */

  listCourses(course) {
    return (
      <div className="course">
        <div className="caixaImg">
          <img
            src={`/imgs/banners_Card/${course.img}`}
            alt={`curso de ${course.title}`}
            onClick={() => {
              this.onCourseClick(course.id, course.index);
            }}
          />

          <div class="sobreposicao">
            <div
              class="texto"
              onClick={() => {
                this.onCourseClick(course.id, course.index);
              }}
            >
              CONHEÇA
            </div>
          </div>
        </div>
        <div className="titleCourse">
          <p className="firstChild">{course.title}</p>
        </div>
        {/* <p className="lastChild">Prof.º {course.teacher}</p>
        <p className="lastChild">Duração: {course.duringTime}</p> */}
      </div>
    );
  }

  onClickGoTo(course) {
    window.open(course.url);
  }

  listCoursesSummer(course) {
    return (
      <div className="courseSummer">
        <img
          src={`/imgs/banners_Card/${course.img}`}
          alt={`curso de ${course.title}`}
          onClick={() => {
            this.onClickGoTo(course);
          }}
        />
        <ul className="courseTitles">
          {course.messages !== undefined
            ? course.messages.map((ele) => (
                <li className="courseTitle" key={ele.mgs}>
                  {ele.mgs}
                </li>
              ))
            : null}
        </ul>
        <img
          className="offersImg"
          src={`/imgs/banners_Card/${course.discount}`}
          alt={`curso de ${course.title}`}
          onClick={() => {
            this.onClickGoTo(course);
          }}
        />
        {/* <p className="firstChild">{course.title}</p> */}
        {/* <p className="lastChild">Prof.º {course.teacher}</p>
          <p className="lastChild">Duração: {course.duringTime}</p> */}
      </div>
    );
  }

  render() {
    const courses = [];
    data.conteudo.forEach((element) => {
      element.forEach((course) => {
        courses.push(course);
      });
    });
    // const listOffersCourses = courses.filter((element) => { return element.section === "Cursos de Verão" })
    const listTecnologyCourses = courses.filter((element) => {
      return element.section === "TECNOLOGIA";
    });
    const listBusinessCourses = courses.filter((element) => {
      return element.section === "NEGÓCIOS";
    });
    const listInovationCourses = courses.filter((element) => {
      return element.section === "INOVAÇÕES";
    });
    return (
      <div className="c-main-courses">
        {/*Curso de verão */}
        <div class="title-wrapper">
          <div className="imageBanner">
            {/* <a href="./valentines-day"> */}
            <img
              src={BannerWorkshop}
              style={{ width: "100%" }}
              alt="Workshop"
            />
            {/* </a> */}
          </div>
        </div>

        {/* Ordem Normal anterior à 'blackfriday' - "Negócios, Tecnologia, Inovação" */}
        {/* <div style={{ backgroundColor: "white", paddingBottom: "100px"}}>
          <div className="coursesOffer" >
                {listOffersCourses.map(element => { return this.listCoursesSummer(element) })}
          </div>

        </div> */}
        <div className="courses-wrapper">
          <div className="container">
            <section id="tecnology">
              <div className="image-title-wrapper">
                <img
                  src={tecnologiaTagline}
                  alt="cursos de tecnologia"
                  id="tag-category"
                  className="imageTitle"
                />
              </div>
              <div id="container-courses">
                {listTecnologyCourses.map((element) => {
                  return this.listCourses(element);
                })}
              </div>
            </section>
          </div>
        </div>
        <div className="courses-wrapper">
          <div className="container">
            <section id="inovation">
              <div className="image-title-wrapper">
                <img
                  src={inovacaoTagline}
                  alt="cursos de inovação"
                  id="tag-category"
                  className="imageTitle"
                />
              </div>
              <div id="container-courses">
                {listInovationCourses.map((element) => {
                  return this.listCourses(element);
                })}
              </div>
            </section>
          </div>
        </div>
        <div className="courses-wrapper">
          <div className="container">
            <section id="business">
              <div className="image-title-wrapper">
                <img
                  src={negociosTagline}
                  alt="cursos de negocios"
                  id="tag-category"
                  className="imageTitle"
                />
              </div>
              <div id="container-courses">
                {listBusinessCourses.map((element) => {
                  return this.listCourses(element);
                })}
              </div>
            </section>
          </div>
        </div>
        {/* Aqui é o local que está atrapalhando o ajuste do layout, ou seja,
            a área de contatos deve ser reajustada de acordo com as dimensões!
        */}
        <div class="contact-simplefooter">
          <div class="footer-father">
            <Simplefooter />
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    window.scroll(0, 0);
  }
}



// WEBPACK FOOTER //
// ./src/components/workshop/workshop.js